const specialSelectorCache = {};

(function ( $ ) {
    var specialSelectorSearchAjax = {};
    $.fn.specialSelector = function(vars) {
        $(this).each(function() {
            var elm = $(this);

            if (elm.prop('tagName') !== 'SELECT') {
                return;
            }

            if(!elm.hasClass('has-special-selector')) {
                elm.addClass('has-special-selector');

                let uid = elm.attr('data-uid');
                if (uid === undefined) {
                    uid = get_unique_id();
                    elm.attr('data-uid', uid);
                }

                //Add an open-button to it, and remove it before
                if (elm.next().hasClass('special-selector-open-button-wrapper')) {
                    elm.next().remove();
                }
                if(vars && vars.onOpen !== undefined && !elm.is('[data-may-not-open]')) {
                    elm.after('<div class="special-selector-open-button-wrapper"><a href="#" class="special-selector-open-button"><span class="visual-icon-spyglass primary"></span></a></div>');
                    const open_button = elm.next();
                    open_button.click(function(e) {
                        e.preventDefault();
                        var prev = $(this).prev();
                        if(prev.prop('tagName') !== 'SELECT') {
                            prev = prev.prev();
                        }
                        if(typeof vars.onOpen !== 'function') {
                            var ext = camelize(elm.attr('data-search-type'))+'Selector';
                            var type = elm.attr('data-search-type').replaceAll('-','_');
                            vars.onOpen = function(id) {
                                var fn = 'view_'+type;
                                eval(fn+'('+id+', function(obj) { elm.removeClass("has-special-selector").attr("data-current-value",obj.id).'+ext+'(obj.id);  })')
                            }
                        }
                        vars.onOpen(prev.val());
                        return false;
                    });
                }

                //Think of an add_new-function when it has not been defined, but when it should be possible
                if(elm.attr('data-may-add-new') !== undefined && (vars.addNew === undefined || typeof vars.addNew !== 'function')) {
                    const ext = camelize(elm.attr('data-search-type'))+'Selector';
                    const type = elm.attr('data-search-type').replaceAll('-','_');
                    vars.addNew = function() {
                        const fn = 'add_'+type;
                        eval(fn+'(function(obj) { elm.removeClass("has-special-selector").attr("data-current-value",obj.id).'+ext+'(obj.id);  })')
                    }
                }
                if(vars.url === undefined) {
                    vars.url = '/ajax/specialSelectorSearch';
                }

                const onSuccess = (data, elm, vars) => {
                    elm.empty();
                    if(elm.attr('data-with-empty') !== undefined) {
                        const str = elm.attr('data-empty-string') === undefined ? 'Geen' : elm.attr('data-empty-string');
                        elm.prepend('<option value="-1">' + str + '</option>');
                    }
                    if(elm.attr('data-with-same') !== undefined) {
                        elm.append('<option value="same">Zelfde</option>');
                    }
                    if(elm.attr('data-make-a-choice') !== undefined) {
                        elm.append('<option value="make_a_choice">'+elm.attr('data-make-a-choice')+'</option>');
                    }
                    if (elm.attr('data-extra-options') !== undefined) {
                        const options = elm.attr('data-extra-options').split('|').map((option) => {
                            return option.split('=');
                        });

                        options.forEach((option) => {
                            elm.append('<option value="' + option[0] + '">' + option[1] + '</option>');
                        });
                    }
                    if(data !== undefined) {
                        for(let i in data) {
                            let row = data[i];

                            if(typeof row !== 'object') {
                                if(vars.nameAttr === undefined) {
                                    vars.nameAttr = 'name';
                                }
                                const str = row;
                                row = {id: i};
                                row[vars.nameAttr] = str;
                            }
                            elm.append(vars.option(row));
                        }
                    }
                    if(elm.attr('data-may-add-new') !== undefined) {
                        elm.append('<option value="0">Nieuw...</option>');
                    }

                    if (vars.placedOptions) {
                        vars.placedOptions(elm);
                    }

                    if(vars.val !== undefined && elm.find('option[value="' + vars.val + '"]').length > 0) {
                        elm.val(vars.val).trigger('change');
                    } else if(elm.attr('data-current-value') !== undefined &&  elm.find('option[value="' + elm.attr('data-current-value') + '"]').length > 0) {
                        elm.val(elm.attr('data-current-value')).trigger('change');
                    } else {
                        elm.trigger('change');
                    }
                    elm.unbind('change.specialSelector').bind('change.specialSelector', function () {
                        elm = $(this);
                        if (parseInt(elm.val()) === 0 && elm.parent().is(':visible')) {
                            elm.val(elm.find('option:first').attr('value'));
                            vars.addNew();
                        }
                        if (parseInt(elm.val()) !== parseInt(elm.attr('data-current-value'))) {
                            elm.removeAttr('data-current-value');
                        }
                    });


                    //Replace the select bar with a searchbar
                    if(elm.attr('data-search-type') !== undefined) {
                        var prev = elm.prev();
                        var search_input = prev;
                        if(!prev.hasClass('special-selector-search-bar')) {
                            elm.before('<input type="text" class="special-selector-search-bar" id="' + uid + '" placeholder="Zoeken..." />');
                            search_input = elm.prev();

                            if(elm.attr('data-make-a-choice') !== undefined) {
                                search_input.val(elm.attr('data-make-a-choice'));
                            }
                            elm.hide();
                        }

                        search_input.prop('disabled', elm.is(':disabled'));
                        search_input.prop('readonly', elm.is('[readonly]'));

                        search_input.unbind('keydown');
                        search_input.unbind('keyup');
                        search_input.unbind('focus');

                        search_input.bind('keydown', function(e) {
                            if (e.keyCode === 13) {
                                e.preventDefault();
                                return false;
                            }
                        })
                        search_input.bind('keyup focus', function(e) {
                            if (elm.is('[readonly]')) {
                                return;
                            }

                            const onSearch = () => {
                                search_input = $(this);
                                elm = search_input.next();
                                const uid = search_input.attr('id');
                                // if ($(`[data-uid="${uid}"]`).length > 1) {
                                //     uid = get_unique_id();
                                //     elm.attr('data-uid', uid);
                                //     search_input.attr('id', uid);
                                // }
                                if(specialSelectorSearchAjax[uid] !== undefined) {
                                    specialSelectorSearchAjax[uid].abort();
                                }

                                var search_results_wrapper = $('.special-selector-search-results-wrapper[data-for="'+uid+'"]');
                                search_results_wrapper.removeClass('closed');

                                $('.special-selector-search-results-wrapper:not([data-for="'+uid+'"]).closed').remove();

                                var reveal = elm.parents('.reveal-overlay');




                                const setResultsPosition = () => {
                                    const calc_max_height = function() {
                                        return $(window).height() - search_input.offset().top - search_input.innerHeight() - 1;
                                    };

                                    const { top, left, height, width } = search_input[0].getBoundingClientRect();
                                    const scrollTop = window.scrollY;
                                    let maxZ = 1000;
                                    if($('.reveal:visible').length > 0) {
                                        maxZ = Math.max.apply(null,
                                            $.map($('.reveal:visible'), function(e,n) {
                                                if ($(e).css('position') !== 'static')
                                                    return parseInt($(e).css('z-index')) || 1;
                                            }));
                                    }
                                    search_results_wrapper.css({
                                        'left': left,
                                        'top': top + scrollTop,
                                        'margin-top': height,
                                        'width': width - 0.5,
                                        'max-height': calc_max_height(),
                                        'z-index': maxZ + 1,
                                        'transform': 'none',
                                    });



                                    const topOffset = top;
                                    const bottomOffset = $(window).height() - topOffset - search_input.outerHeight();

                                    if(topOffset > bottomOffset) {
                                        //Show it on top
                                        search_results_wrapper.css({
                                            'max-height': topOffset * 0.8,
                                            'margin-top': 0,
                                            'transform': 'translateY(-100%)'
                                        });
                                        search_results_wrapper.addClass('reversed-results');
                                    } else {
                                        search_results_wrapper.removeClass('reversed-results');
                                    }
                                }
                                //var prev = search_input.prev();
                                //var search_results_wrapper = prev;
                                if(search_results_wrapper.length === 0) {
                                    //This puts it after the input, which prevents the div from going out of the popup
                                    //elm.after('<div class="special-selector-search-results-wrapper" data-for="'+uid+'"><ul></ul></div>');
                                    //This puts it at the beginning of the body, which enables you to view the div outside of the popup
                                    $('body').prepend('<div class="special-selector-search-results-wrapper" data-init-scroll="'+reveal.scrollTop()+'" data-for="'+uid+'"><ul></ul></div>');

                                    search_results_wrapper = $('.special-selector-search-results-wrapper[data-for="'+uid+'"]:first');


                                    const revealOverlay = elm.parents('.reveal-overlay');
                                    if (revealOverlay.length > 0) {
                                        revealOverlay.bind('scroll',function() {
                                            setResultsPosition();
                                        });
                                    }
                                    $('body').bind('scroll', function() {
                                        setResultsPosition();
                                    })



                                    $(window).unbind('resize.'+uid).bind('resize.'+uid, function() {
                                        search_results_wrapper.remove();
                                    });

                                    search_input.blur(function() {
                                        setTimeout(() => {
                                            search_results_wrapper.height(0);
                                            search_results_wrapper.addClass('closed');
                                            if(search_input.attr('data-current-value') !== undefined && search_input.val().length === 0) {
                                                //The is where you should look out for &amp;
                                                search_input.val(elm.find('option[value='+search_input.attr('data-current-value')+']').html());
                                            }
                                        })
                                    }.bind([elm, search_input, search_results_wrapper]));
                                } else {

                                    // search_results_wrapper.css({
                                    //     'left': search_input.offset().left,
                                    //     'top': search_input.offset().top,
                                    //     'transform': 'none',
                                    // });

                                    search_results_wrapper.prop('data-init-scroll',reveal.scrollTop());
                                }
                                setResultsPosition();



                                search_results_wrapper.find('li').remove();
                                search_results_wrapper.height(search_input.outerHeight() * 3);
                                search_results_wrapper.isLoading();

                                if(search_input.attr('data-current-value') !== undefined && e.keyCode === undefined) {
                                    if(search_input.attr('data-current-value') === "-1") {
                                        search_input.val('');
                                    }
                                }

                                let v = search_input.val();
                                if(e.keyCode === undefined || e.keyCode === 9) {
                                    //If focused, search all
                                    search_input.select();
                                    v = null;
                                } else {
                                    //If typed, set the value to null
                                    search_input.next().val(0);
                                }

                                let filters = {};
                                if(elm.attr('data-filter-key')) {
                                    filters = elm.getSetFilters();
                                }



                                specialSelectorSearchAjax[uid] = $.ajax({
                                    url: '/ajax/specialSelectorSearch',
                                    data: {v: v, type: elm.attr('data-search-type'), filters: filters},
                                    success: function(data) {
                                        search_results_wrapper.doneLoading();
                                        $.each(data, function(id, description) {
                                            if (typeof description === 'object') {
                                                const tmpSelect = $('<select />');
                                                tmpSelect.append(vars.option(description));

                                                id = description.id;
                                                description = tmpSelect.find('option').text();
                                            }
                                            search_results_wrapper.find('ul').append('<li data-value="'+id+'">'+description+'</li>');
                                        });


                                        if(elm.attr('data-with-empty') !== undefined) {
                                            const str = elm.attr('data-empty-string') === undefined ? 'Geen' : elm.attr('data-empty-string');
                                            search_results_wrapper.find('ul').prepend('<li data-value="-1"><em>' + str + '</em></li>');
                                        }
                                        if (elm.attr('data-extra-options') !== undefined) {
                                            const options = elm.attr('data-extra-options').split('|').map((option) => {
                                                return option.split('=');
                                            });

                                            options.forEach((option) => {
                                                search_results_wrapper.find('ul').prepend('<li data-value="' + option[0] + '">' + option[1] + '</li>');
                                            });
                                        }
                                        if(elm.attr('data-with-same') !== undefined) {
                                            search_results_wrapper.find('ul').append('<li data-value="same"><em>Zelfde</em></li>');
                                        }
                                        if(elm.attr('data-may-add-new')  !== undefined) {
                                            search_results_wrapper.find('ul').prepend('<li data-value="0"><em>Nieuw...</em></li>');
                                        }

                                        search_results_wrapper.find('li[data-value="'+elm.val()+'"]').attr('data-selected', 1);

                                        search_results_wrapper.height(search_results_wrapper.find('ul').outerHeight());

                                        search_results_wrapper.find('li').bind('mousedown', function() {
                                            var li = $(this);
                                            var value = li.attr('data-value');
                                            var search_results_wrapper = $(this).parents('.special-selector-search-results-wrapper');
                                            var input = $('.special-selector-search-bar#'+search_results_wrapper.attr('data-for'));
                                            var select = input.next();

                                            select.html('<option value="'+value+'">'+li.text()+'</option>');
                                            select.val(value).trigger('change');


                                            input.blur();
                                        });
                                        if((v == null || v.length === 0) && e.keyCode !== undefined && e.keyCode === 13) {
                                            search_results_wrapper.find('li[data-value="-1"]').click();
                                        }
                                    }
                                });
                            }

                            if (search_input[0].debouncedFn !== undefined) {
                                search_input[0].debouncedFn.cancel();
                            }
                            search_input[0].debouncedFn = _.debounce(onSearch, e.type === 'focus' ? 0 : 300);
                            search_input[0].debouncedFn();
                        });

                        elm.unbind('change.specialSelectorSearcher').bind('change.specialSelectorSearcher', function() {
                            if (elm.is('[data-reset-after-choice]')) {
                                search_input.attr('data-current-value', 'make_a_choice');
                                search_input.val(elm.attr('data-make-a-choice'));
                            } else {
                                search_input.attr('data-current-value', elm.val());
                                search_input.val(elm.find('option[value='+elm.val()+']').text());
                            }

                            if (!elm.is('[data-mandatory]') || elm.is('[data-mandatory="true"]')) {
                                elm.parents('form:first').find('[type="submit"]').attr('disabled', elm.val() === 'make_a_choice');
                            }

                        }.bind([search_input, elm])).trigger('change');

                        elm.parents('form').unbind('submit.specialSelectorSearcher').bind('submit.specialSelectorSearcher', function() {
                            $(this).find('.special-selector-search-bar').each(function() {
                                $('.special-selector-search-results-wrapper[data-for="'+$(this).attr('id')+'"]').height(0);
                            });
                        });
                    }
                };

                const ajaxParams = {
                    url: vars.url,
                    type: 'GET',
                    dataType: 'json',
                    // success: function(data) {
                    //     onSuccess(data, elm, vars);
                    // }.bind([elm, vars])
                };

                const was_empty = vars.params === undefined;

                if(vars.params) {
                    ajaxParams.data = vars.params;
                } else if(elm.attr('data-current-value') !== undefined && elm.attr('data-current-value') >= 0) {
                    ajaxParams.data = {id: elm.attr('data-current-value')};
                } else if(vars.val !== undefined) {
                    ajaxParams.data = {id: vars.val};
                }
                if(was_empty) {
                    if(ajaxParams.data === undefined) {
                        ajaxParams.data = {limit: 1};
                    } else {
                        ajaxParams.data['limit'] = 1;
                    }
                }
                if(vars.url === '/ajax/specialSelectorSearch') {
                    if (vars.type) {
                        ajaxParams.data['type'] = vars.type;
                    } else {
                        ajaxParams.data['type'] = elm.attr('data-search-type');
                    }
                }

                // Save these params in order to get them via jQ.getObject.
                elm[0].ajaxParams = ajaxParams;


                // get all attributes with values from the elm and put them into an object
                const attributes = {};
                for (let i = 0; i < elm[0].attributes.length; i++) {
                    const attr = elm[0].attributes[i];
                    attributes[attr.name] = attr.value;
                }

                const key = btoa(JSON.stringify([ajaxParams.url, ajaxParams.data, ajaxParams.type, attributes]));



                if (!vars.noPromises && specialSelectorCache[key] && ((new Date()).getTime() - specialSelectorCache[key].timestamp) < 1000) {
                    Promise.resolve(specialSelectorCache[key].promise).then((data) => {
                        onSuccess(data, elm, vars);
                    });
                } else {
                    if(specialSelectorSearchAjax[uid] !== undefined) {
                        specialSelectorSearchAjax[uid].abort();
                    }
                    specialSelectorCache[key] = {
                        timestamp: (new Date()).getTime(),
                        promise: new Promise((resolve) => {
                            ajaxParams.success = (data) => {
                                onSuccess(data, elm, vars);
                                resolve(data);
                            };
                            specialSelectorSearchAjax[uid] = $.ajax(ajaxParams);
                        })
                    }
                }


                elm.unbind('resetValue').on('resetValue', function(event, value) {
                    const fn = elm.attr('data-search-type') + 'Selector';
                    const parts = fn.split('-');
                    const words = [];
                    parts.forEach((p, index) => {
                        let firstLetter = p.substring(0, 1).toLowerCase();
                        if (index > 0) firstLetter = firstLetter.toUpperCase();
                        words.push(firstLetter + p.substring(1));
                    });
                    const functionName = words.join('');
                    eval('elm.removeClass(\'has-special-selector\').' + functionName + '(value);');
                });
            }
        });
        return this;
    };

}( jQuery ));
(function ( $ ) {
    $.fn.setValue = function(value) {
        const elm = this;
        if (!elm.hasClass('has-special-selector')) {
            elm.val(value);
            return elm;
        }
        elm.trigger('resetValue', [value]);
    };

}( jQuery ));
(function ( $ ) {
    $.fn.getSetFilters = function() {
        const elm = this;

        const id = get_unique_id();
        $('body').append('<form id="'+id+'"></form>');
        const form = $('form#'+id);
        form.hide();
        $('[data-'+elm.attr('data-filter-key')+'-filter]').each(function() {
            const v = $(this).val();
            const clone = $(this).clone();
            if (!clone.is('[name]')) {
                clone.attr('name', $(this).attr('data-name'));
            }
            if (clone.is('[data-filter-name]')) {
                clone.attr('name', $(this).attr('data-filter-name'));
            }
            clone.val(v).appendTo(form);
        });
        const data = form.serializeJSON();
        form.remove();
        return data;
    };

}( jQuery ));


jQuery(document).ready(function($) {
    const sel =  $('select');
    if (sel.length > 0) {
        sel.each(function() {
            let attributes = [...$(this)[0].attributes];
            attributes = attributes
                .map((attribute) => {
                    return attribute.localName;
                })
                .filter((attribute) => {
                    return attribute.substr(0, ('data-').length) === 'data-' && attribute.split('').reverse().join('').substr(0, ('-selector').length).split('').reverse().join('') === '-selector';
                });
            if (attributes.length > 0) {
                const type = attributes[0].substr(('data-').length, (attributes[0].length - ('data-').length - ('-selector').length));
                eval('$(this).' + type + 'Selector();');
            }
        });
    }
});
